var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"acronis-prolong"},[_c('div',{staticClass:"acronis-prolong__header"},[_c('div',{staticClass:"acronis-prolong__title big-title"},[_vm._v(" "+_vm._s(_vm.$t('subtitle'))+" ")])]),_c('main-card',[_c('div',[_vm._v(_vm._s(_vm.value.v))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }